import { getActiveWorkspace } from '../utilities/getActiveWorkspace';
export function setVerticalSplitterPosition(draft, action) {
    const currentWorkspacePreferences = getActiveWorkspace(draft);
    currentWorkspacePreferences.general.verticalSplitterPosition =
        action.payload.value;
}
